module.exports = __webpack_public_path__ + "static/media/phoenix_1.638bd39b.jpg";